import { handleActions } from 'redux-actions';
import * as Actions from '../../actions';

const initialState = {
	saved: {
		data: null
	},
	updated: {
		data: null
	},
	deleted: {
		data: null
	}
};

const rolePolicyReducer = handleActions(
	{
		[Actions.createRolePolicySuccess]: (state, action) => {
			return {
				...state,
				saved: { data: action.payload },
				updated: { data: null },
				deleted: { data: null }
			};
		},
		[Actions.updateRolePolicySuccess]: (state, action) => {
			return {
				...state,
				saved: { data: null },
				updated: { data: action.payload },
				deleted: { data: null }
			};
		},
		[Actions.deleteRolePolicySuccess]: (state, action) => {
			return {
				...state,
				saved: { data: null },
				updated: { data: null },
				deleted: { data: action.payload }
			};
		}
	},
	initialState
);

export default rolePolicyReducer;
